import { memo } from 'react';

function SaveIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="19"
			fill="none"
			viewBox="0 0 19 19"
			{...props}
		>
			<path
				fill="#607EFE"
				d="M7.528 12.302 15.4 4.43l1.211 1.21-9.083 9.084-5.45-5.45L3.29 8.063z"
			></path>
		</svg>
	);
}

export default memo(SaveIcon);
